"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureDataDogRum = configureDataDogRum;
var _browserRum = require("@datadog/browser-rum");
function configureDataDogRum(config) {
  const {
    ddApplicationId,
    ddClientToken,
    ddDefaultPrivacyLevel,
    ddRumEnabled,
    ddRumSessionRecordingEnabled,
    ddSampleRate,
    ddServiceName,
    ddTrackInteractions,
    environment,
    releaseVersion,
    logInfo
  } = config;
  if (!ddRumEnabled) {
    return;
  }
  const rumConfig = {
    env: environment,
    clientToken: ddClientToken,
    applicationId: ddApplicationId,
    sampleRate: ddSampleRate || 100,
    site: 'datadoghq.eu',
    service: ddServiceName,
    version: releaseVersion,
    trackInteractions: ddTrackInteractions === undefined ? true : ddTrackInteractions,
    defaultPrivacyLevel: ddDefaultPrivacyLevel || undefined
  };
  logInfo(`Configuring DataDog with ${JSON.stringify(rumConfig)}`);
  _browserRum.datadogRum.init(rumConfig);
  if (ddRumSessionRecordingEnabled) {
    _browserRum.datadogRum.startSessionReplayRecording();
  }
}